import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.search";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import qs from 'qs';

var ShopifyAuthorizePage = function (_super) {
  __extends(ShopifyAuthorizePage, _super);

  function ShopifyAuthorizePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.message = _this.t('授权处理中，请稍等');
    _this.loading = true;
    return _this;
  }

  ShopifyAuthorizePage.prototype.created = function () {
    var _this = this;

    this.$router.onReady(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
          queryParams = qs.parse(window.location.search, {
            ignoreQueryPrefix: true
          });
          queryParams && this.installApp(queryParams);
          return [2];
        });
      });
    });
  };

  ShopifyAuthorizePage.prototype.installApp = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var data, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4, this.$api.platform.installShopify(params)];

          case 1:
            data = _a.sent().data;
            window.location.href = data.url;
            return [3, 3];

          case 2:
            e_1 = _a.sent();
            this.loading = false;
            this.message = this.t('处理授权出错，请联系客户支持反馈处理');
            return [3, 3];

          case 3:
            return [2];
        }
      });
    });
  };

  ShopifyAuthorizePage = __decorate([Component], ShopifyAuthorizePage);
  return ShopifyAuthorizePage;
}(Vue);

export default ShopifyAuthorizePage;